import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { spWalletList, clientWalletList } from '../../models/wallet.models'
import { TranslateService } from '@ngx-translate/core'

@Component({
	selector: 'app-wallet-table',
	templateUrl: './wallet-table.component.html',
	styleUrls: ['./wallet-table.component.scss'],
})
export class WalletTableComponent implements OnInit {
	@Input() clientWallets: clientWalletList[] = []
	@Input() spWallets: spWalletList[] = []
	subscription = new Subscription()
	@Input() walletFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },
		searchText: '',
		// activeTab: 0,
		countryId: null,
		organizationId: '' || null,
		branchId: '' || null,
	}
	@Input() totalCount = 0
	@Input() totalCountClient = 0
	@Output() actionChanged: EventEmitter<any> = new EventEmitter()
	constructor(private router: Router, public translate: TranslateService) {}

	ngOnInit(): void {}
	viewDetails(obj: any) {
		this.walletFilter.activeTab == 0
			? this.router.navigateByUrl(`/layout/wallet/sp-wallet/${obj.branchId}`)
			: this.router.navigateByUrl(
					`/layout/clients/client-profile/${obj.cientId}`
			  )
	}
}
